import { AxiosResponse } from 'axios'
import { api } from './api'

export interface Template {
  id: string
  name: string
  content: string
  header?: string
  footer?: string
  headerHeight?: string
  footerHeight?: string
  landscape?: boolean
  format?: string
}

type sortParams = {
  orderBy?: string | null
  order?: string | null
  offset?: Number
  limit?: Number
}
export default class TemplateService {
  static async list(params?: sortParams): Promise<Template[]> {
    const response: AxiosResponse = await api.get('/v1/reporting/templates', {
      params
    })
    return response.data
  }

  static async getOne(id: string): Promise<Template> {
    const response: AxiosResponse = await api.get(
      `/v1/reporting/templates/${id}`
    )
    return response.data
  }

  static async create(template: Template): Promise<Template> {
    const response: AxiosResponse = await api.post(
      '/v1/reporting/templates',
      template
    )
    return response.data
  }

  static async delete(id: string): Promise<null> {
    const response: AxiosResponse = await api.delete(
      `/v1/reporting/templates/${id}`
    )
    return response.data
  }

  static async update(id: string, template: Template): Promise<Template> {
    const response: AxiosResponse = await api.put(
      `/v1/reporting/templates/${id}`,
      template
    )
    return response.data
  }
}
